export const weekdayRows = [
  { prefix: 'mon', label: 'ПН' },
  { prefix: 'tue', label: 'ВТ' },
  { prefix: 'wed', label: 'СР' },
  { prefix: 'thu', label: 'ЧТ' },
  { prefix: 'fri', label: 'ПТ' },
  { prefix: 'sat', label: 'СБ' },
  { prefix: 'sun', label: 'ВС' },
];

export const holidayRow = { prefix: 'hol', label: 'Праздник' };

export const weekdayToggleFields = ['use_freeperiod', 'use_first_paid_day', 'use_holidays'];

export const weekdayNumberFields = [...weekdayRows, holidayRow].flatMap((row) => [`${row.prefix}_hour_cost`, `${row.prefix}_free_interval`]);
